import React, { useCallback, useState } from "react";
import Navbar from "./Navbar";
import { loadSlim } from "tsparticles-slim";
import Particles from "react-tsparticles";
import icecube from "../../assets/icube.png";
import pic from "../../assets/pic1.png";
import pic2 from "../../assets/pic2.png";
import pic3 from "../../assets/pic3.png";
import cubes from "../../assets/2cubes.png"
import Cart from "./Cart";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setEvent } from "../../slices/coffeSlice";

export default function Landing() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const events = [
    {
      id: 1,
      image: pic,
      fechaShort: "11/03/25",
      fecha: "11 de Abril del 2025",
      hora: "12:00 am - 02:00 pm ",
      lugar: "Trinidad Villagomez #42",
      price: 500,
      tipo: "Cold body",
    },
    {
      id: 2,
      image: pic2,
      fechaShort: "17/03/25",
      fecha: "17 de Abril del 2025",
      hora: "10:00 am - 12:00 pm ",
      lugar: "Av Patria #12 ",
      price: 499,
      tipo: "Cold breath",
    },
    {
      id: 3,
      image: pic3,
      fechaShort: "22/03/25",
      fecha: "22 de Abril del 2025 ",
      hora: "1:00 pm - 03:00 pm ",
      lugar: "Lomas del Country 125 ",
      price: 429,
      tipo: "Cold mind",
    },
  ];

  const [isCartOpen, setIsCartOpen] = useState(false);

  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    console.log(container);
  }, []);

  const handleNavigate = (event) => {
    dispatch(setEvent(event));
    navigate("/evento");
  };

  return (
    <div className="w-full min-h-screen">
    <Navbar/>
      <Cart isCartOpen={isCartOpen} setIsCartOpen={setIsCartOpen} />

      <div className="relative w-full h-[310vh] xl:h-[270vh] 3xl:h-[200vh] ">
        <div className="absolute top-0 left-0 w-full h-full z-[40] ">
          <div className="w-full bg-transparent mt-40 z-50">
            <h1 className="text-mandarin text-6xl text-center font-semibold ">
              Tipos de Eventos
            </h1>

            <div className="flex  flex-wrap sm:px-20  px-5 justify-center mt-10 gap-10 mb-[200px] ">
              

              <div className="w-[400px] relative h-[600px] border-2 border-mandarin flex flex-col rounded-lg items-center justify-center yoga-background  ">
              <div className="sm:w-[400px] w-[350px] h-[600px] bg-black/50 absolute rounded-lg -z-0 " ></div>
                <h1 className="text-mandarin textborder font-[900]  z-10  p-1 rounded-lg text-5xl  text-center">
                  Cold body
                </h1>
                <p className="text-white text-lg  font-bold text-center z-10  p-1 rounded-lg ">
                  Mejora tu felxibilidad fisica y mental{" "}
                </p>
                <button className="mt-10 bg-white text-mandarin hover:scale-[1.03] transition-all ease-out z-10 p-2 px-5 rounded-lg text-xl flex gap-2 items-center ">
                  Conoce mas
                  <img className="w-12 h-8" src={cubes} alt="" />
                </button>
              </div>

              <div className="w-[400px] relative  h-[600px] border-2 border-mandarin flex flex-col rounded-lg items-center justify-center breath-background ">
              <div className="sm:w-[400px] w-[350px] h-[600px] bg-black/50 rounded-lg absolute -z-0 " ></div>
                <h1 className="text-mandarin text-6xl z-10 textborder p-1 rounded-lg font-bold text-center">
                  Cold breath
                </h1>
                <p className="text-white text-center z-10 font-bold   p-1 rounded-lg">
                  Conoce lo beneficios de una buena respiracion
                </p>
                <button className="mt-10 bg-white text-mandarin hover:scale-[1.03] transition-all ease-out z-10 p-2 px-5 rounded-lg text-xl flex gap-2 items-center ">
                  Conoce mas
                  <img className="w-12 h-8" src={cubes} alt="" />
                </button>
              </div>

              <div className="w-[400px] relative h-[600px]  border-2 border-mandarin flex flex-col  rounded-lg items-center justify-center mind-background ">
              <div className="sm:w-[400px] w-[350px] h-[600px] bg-black/50 rounded-lg absolute -z-0 " ></div>
                <h1 className="text-mandarin textborder text-6xl z-10  rounded-lg p-1 font-bold text-center">
                  Cold mind
                </h1>
                <p className="text-white text-lg text-center  font-bold z-10  rounded-lg p-1 ">
                  Nutre tu mente y nunca dejes de aprender
                </p>
                <button className="mt-10 bg-white text-mandarin hover:scale-[1.03] transition-all ease-out z-10 p-2 px-5 rounded-lg text-xl flex gap-2 items-center ">
                  Conoce mas
                  <img className="w-12 h-8" src={cubes} alt="" />
                </button>
              </div>

              <div className="w-[400px] relative p-2 h-[600px] border-2 border-mandarin flex flex-col rounded-lg items-center justify-center hielo-background ">
              <div className="sm:w-[400px] w-[350px] h-[600px] bg-black/50 rounded-lg absolute -z-0 " ></div>
                <h1 className="text-mandarin textborder z-10 rounded-lg p-1 text-5xl font-bold text-center">
                  Cold Connect
                </h1>
                <p className="text-white text-lg font-bold z-10 rounded-lg p-1  text-center ">
                  La vida es para disfrutar y que mejor que con unos buenos
                  hielocos
                </p>
                <button className="mt-10 bg-white text-mandarin hover:scale-[1.03] transition-all ease-out z-10 p-2 px-5 rounded-lg text-xl flex gap-2 items-center ">
                  Conoce mas
                  <img className="w-12 h-8" src={cubes} alt="" />
                </button>
              </div>
            </div>
          </div>

          <div className="sm:block  hidden">
            <Particles
              id="tsparticles-large"
              init={particlesInit}
              loaded={particlesLoaded}
              options={{
                particles: {
                  number: {
                    value: 8,
                    density: {
                      enable: true,
                      value_area: 800,
                    },
                  },
                  line_linked: {
                    enable: false,
                  },
                  move: {
                    enable: true,
                    speed: 2,
                    outMode: "bounce",
                    direction: "none",
                    straight: false,
                  },
                  shape: {
                    type: ["image"],
                    image: [
                      {
                        src: icecube,
                        height: 20,
                        width: 23,
                      },
                    ],
                  },
                  color: {
                    value: "#CCC",
                  },
                  size: {
                    value: 25,
                    random: false,
                    anim: {
                      enable: true,
                      speed: 4,
                      size_min: 10,
                      sync: false,
                    },
                  },
                  interactivity: {
                    events: {
                      onHover: {
                        enable: true,
                        mode: "bubble",
                      },
                      onClick: {
                        enable: true,
                        mode: "push",
                      },
                    },
                    modes: {
                      bubble: {
                        distance: 200,
                        size: 6,
                        duration: 2,
                        opacity: 0.8,
                        speed: 3,
                      },
                      push: {
                        particles_nb: 4,
                      },
                    },
                  },
                },
                retina_detect: false,
              }}
            />
          </div>

          <div className="sm:hidden block">
            <Particles
              id="tsparticles-mobile"
              init={particlesInit}
              loaded={particlesLoaded}
              options={{
                particles: {
                  number: {
                    value: 25,
                    density: {
                      enable: true,
                      value_area: 800,
                    },
                  },
                  line_linked: {
                    enable: false,
                  },
                  move: {
                    enable: true,
                    speed: 2,
                    outMode: "bounce",
                    direction: "none",
                    straight: false,
                  },
                  shape: {
                    type: ["image"],
                    image: [
                      {
                        src: icecube,
                        height: 20,
                        width: 23,
                      },
                    ],
                  },
                  color: {
                    value: "#CCC",
                  },
                  size: {
                    value: 20,
                    random: false,
                    anim: {
                      enable: true,
                      speed: 4,
                      size_min: 10,
                      sync: false,
                    },
                  },
                  interactivity: {
                    events: {
                      onHover: {
                        enable: true,
                        mode: "bubble",
                      },
                      onClick: {
                        enable: true,
                        mode: "push",
                      },
                    },
                    modes: {
                      bubble: {
                        distance: 200,
                        size: 6,
                        duration: 2,
                        opacity: 0.8,
                        speed: 3,
                      },
                      push: {
                        particles_nb: 4,
                      },
                    },
                  },
                },
                retina_detect: false,
              }}
            />
          </div>
        </div>
      </div>

      <div className=" p-8 relative z-40 sm:-mt-[97vh] mt-[30vh]  ">
        <div className="flex justify-center mb-9 mt-12 ">
          <h1 className="text-7xl text-mandarin font-bold ">
            Proximos eventos
          </h1>
        </div>
        <div className="flex flex-wrap justify-center gap-12">
          {events.map((event) => (
            <div
              key={event.id}
              onClick={() => handleNavigate(event)}
              className="relative border-[5px] border-mandarin rounded-[30px] cursor-pointer hover:scale-[1.03] transition-all ease-out "
            >
              <h1 className="absolute text-white bg-mandarin text-4xl p-2 px-5 rounded-lg sm:top-3 top-1 xl:right-24 3xl:right-40 right-12 ">{event.tipo} </h1>
              <img
                className="w-[510px] sm:h-[680px] xl:w-[400px] 3xl:w-[500px] rounded-[30px]"
                src={event.image}
                alt=""
              />
              <h1 className="absolute  left-7 xl:left-10 text-6xl xl:text-7xl text-mandarin font-extrabold top-52 sm:top-[360px]">
                {event.fechaShort}
              </h1>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
